import styles from '@/components/shareCollaborate/search/css/noPerson.module.scss';
import classNames from 'classnames';
import Icon, {IconSize} from '@/components/Icon';
interface INoPerson {
    text?: string;
    linkText?: string;
    svg: any;
    className?: string;
    retry?: () => void;
}
export default (props: INoPerson) => {
    const {text, retry, svg, className, linkText = '点击重试'} = props;
    function handleRetry() {
        retry && retry();
    }
    return (
        <>
            <div className={classNames(styles.statusBox, className)}>
                <Icon
                    svg={svg}
                    className={styles.statusImg}
                    size={IconSize.Auto}
                />
                <span className={styles.noPersonText}>
                    {text}{retry && <a className={'retryStyle'} onClick={handleRetry}>{linkText}</a>}
                </span>
            </div>
        </>
    );
};

